module.exports = __webpack_public_path__ + "img/b97b302.gif";